import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
	{
		path: '/',
		name: 'Index',
		component: () => import( /* webpackChunkName: "about" */ '../views/Index.vue'),
		meta: {title: '游戏活动'}
	},
	{
		path: '/form',
		name: 'form',
		component: () => import( /* webpackChunkName: "about" */ '../views/form.vue'),
		meta: {title: '表单填写'}
	},
	{
		path: '/collect',
		name: 'collect',
		component: () => import( /* webpackChunkName: "about" */ '../views/collect.vue'),
		meta: {title: '问卷答题'}
	},
	{
		path: '/answer',
		name: 'answer',
		component: () => import( /* webpackChunkName: "about" */ '../views/answer.vue'),
		meta: {title: '问卷答案'}
	},
	{
		path: '/vote',
		name: 'vote',
		component: () => import( /* webpackChunkName: "about" */ '../views/vote.vue'),
		meta: {title: '投票'}
	},
	{
		path: '/finish',
		name: 'finish',
		component: () => import( /* webpackChunkName: "about" */ '../views/finish.vue'),
		meta: {title: '游戏活动'}
	}
]

const router = new VueRouter({
	routes
})

export default router
router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面 title */
  if (to.meta.title) {
	document.title = to.meta.title
  }
  next()
})